export default __webpack_public_path__ + "static/media/Boombox_Preview_Transparent.b0d3cee0.png";